export const defaultLocale = "en-GB";

export const availableLocales = {
	"en-GB": "English",
	fi: "Suomi",
	"sv-SE": "Svenska",
};
